import { Item, Modal, Subheader } from "@obs/base";
import { ChevronRightIcon } from "@obs/icons";
import { capitalizeFirstLetter, getCountryCode, getRegionCode } from "@obs/utils";

import { getFlagIllustrationIcon } from "./getFlagIllustrationIcon";
import { useLocale } from "./Provider";

export type SwitcherModalProps = {
	subheader: string;
	isDialogOpen: boolean;
	setIsDialogOpen: (isOpen: boolean) => void;
};

export const SwitcherModal = ({ isDialogOpen, setIsDialogOpen, subheader }: SwitcherModalProps) => {
	const { setLocale, supportedLocales } = useLocale();

	const formatLanguage = (localeCode: string) => {
		const languageNames = new Intl.DisplayNames([localeCode], {
			type: "language",
			languageDisplay: "standard",
		});
		return capitalizeFirstLetter(languageNames.of(getCountryCode(localeCode)));
	};

	const formatRegion = (localeCode: string) => {
		const regionNames = new Intl.DisplayNames([localeCode], { type: "region" });
		return capitalizeFirstLetter(regionNames.of(getRegionCode(localeCode)));
	};
	return (
		<Modal.Default open={isDialogOpen} onOpenChange={() => setIsDialogOpen(false)}>
			<Subheader>{subheader}</Subheader>
			{supportedLocales.map((localeCode) => {
				const flagIllustrationIcon = getFlagIllustrationIcon(localeCode);

				return (
					<Item.Button
						render={
							<button
								type="button"
								onClick={() => {
									setLocale(localeCode);
									setIsDialogOpen(false);
								}}
							/>
						}
						key={localeCode}
						prefix={
							flagIllustrationIcon
								? {
										icon: {
											Component: flagIllustrationIcon,
										},
									}
								: undefined
						}
						suffix={{
							icon: {
								Component: ChevronRightIcon,
							},
						}}
						content={{
							type: "DEFAULT",
							title: {
								content: formatLanguage(localeCode),
							},
							description: getRegionCode(localeCode) ? formatRegion(localeCode) : undefined,
						}}
					/>
				);
			})}
		</Modal.Default>
	);
};
